// ShopLogo / ShopName — the ONE brand identity components for the public booking site. Logo, name,
// and tagline read live from the shared websiteConfig (Firestore website_config), with bundled/default
// fallbacks. Uploading a logo / editing name & tagline in the staff Website settings updates the nav,
// footer, and Client Login modal at once. Jose 2026-09-06.
import React, { useEffect, useState } from 'react';
import { getWebsiteConfig } from '../services/websiteConfigService';

// Transparent engraved beard mark — reads clean on any surface (no white box). (Jose 2026-10-17)
export const SHOP_LOGO_URL = '/assets/branding/beard-mark.png';
export const SHOP_NAME = 'SLIK Barber Lounge';
export const SHOP_TAGLINE = 'Grooming for Every Man';

let _brandingPromise: Promise<{ logo?: string; name?: string; tagline?: string }> | null = null;
function loadBranding() {
  if (!_brandingPromise) {
    _brandingPromise = getWebsiteConfig()
      .then((c) => ({ logo: c.logo, name: c.shopInfo?.name, tagline: (c as any).tagline }))
      .catch(() => ({}));
  }
  return _brandingPromise;
}

/** Live shop branding (logo + name + tagline) from websiteConfig, with the bundled/default fallbacks. */
export function useShopBranding(): { logoUrl: string; name: string; tagline: string } {
  const [b, setB] = useState({ logoUrl: SHOP_LOGO_URL, name: SHOP_NAME, tagline: SHOP_TAGLINE });
  useEffect(() => {
    let alive = true;
    loadBranding().then((r) => {
      if (alive) setB({ logoUrl: r.logo || SHOP_LOGO_URL, name: r.name || SHOP_NAME, tagline: r.tagline || SHOP_TAGLINE });
    });
    return () => { alive = false; };
  }, []);
  return b;
}

export const ShopLogo: React.FC<{ className?: string; alt?: string }> = ({
  className = 'h-10 w-10 object-contain rounded-lg',
  alt = 'SLIK Barber Lounge',
}) => {
  const { logoUrl } = useShopBranding();
  return <img src={logoUrl} alt={alt} className={className} />;
};

/** Shop name with the tagline ALWAYS underneath it. One component so lettering is tuned in one place. */
export const ShopName: React.FC<{ nameClassName?: string; taglineClassName?: string; className?: string }> = ({
  nameClassName = 'text-xl font-bold text-slik-navy',
  taglineClassName = 'text-xs text-gray-500',
  className = '',
}) => {
  const { name, tagline } = useShopBranding();
  return (
    <div className={`leading-tight ${className}`}>
      <div className={nameClassName}>{name}</div>
      {tagline && <div className={taglineClassName}>{tagline}</div>}
    </div>
  );
};

export default ShopLogo;
